document.addEventListener('alpine:init', () => {
  Alpine.store('filterDrawer', {
    isOpen: false,
    activeProductType: '',
    activeSort: '',
    productCount: 0,
    loading: false,
    mobileDropdownOpen: false,

    init() {
      // Initialize active states from URL on page load
      const urlParams = new URLSearchParams(window.location.search);
      this.activeProductType = urlParams.get('filter.p.product_type') || '';
      this.activeSort = urlParams.get('sort_by') || 'featured';
      
      // Initialize product count from page data
      const collectionData = document.querySelector('[data-collection-count]');
      if (collectionData) {
        this.productCount = parseInt(collectionData.dataset.collectionCount) || 0;
      }
      
      // Close drawer if filters were just applied (page reload after form submission)
      // We can detect this by checking if any filters are active in URL
      const hasActiveFilters = urlParams.has('filter.p.product_type') || 
                              urlParams.has('sort_by') || 
                              Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
      
      if (hasActiveFilters) {
        this.isOpen = false;
      }

      // Alpine will handle filter changes through @change events
    },

    toggle() {
      this.isOpen = !this.isOpen;
    },

    toggleMobileDropdown() {
      this.mobileDropdownOpen = !this.mobileDropdownOpen;
    },

    async setProductType(value) {
      // Update hidden radio inputs in drawer form
      const form = document.querySelector('.c-filter-form');
      if (form) {
        // Clear all product type radios first
        const radios = form.querySelectorAll('input[name="filter.p.product_type"]');
        radios.forEach(radio => radio.checked = false);
        
        // Set the selected value
        const targetRadio = form.querySelector(`input[name="filter.p.product_type"][value="${value}"]`);
        if (targetRadio) {
          targetRadio.checked = true;
          this.activeProductType = value;
          
          // Update URL parameters
          this.updateURLParams({ 'filter.p.product_type': value });
          
          // Update preview count briefly before submitting
          await this.updateProductCount();
          
          // Announce filtering to screen readers
          const gridStatus = document.getElementById('product-grid-status');
          if (gridStatus) {
            gridStatus.textContent = value ? `Filtering products by ${value}` : 'Filtering products...';
          }
          
          // Then submit form
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

          // Close the drawer and mobile dropdown
          this.isOpen = false;
          this.mobileDropdownOpen = false;
        }
      }
    },

    setSort(value) {
      // Update sort radio inputs in drawer form
      const form = document.querySelector('.c-filter-form');
      if (form) {
        // Clear all sort radios first
        const radios = form.querySelectorAll('input[name="sort_by"]');
        radios.forEach(radio => radio.checked = false);
        
        // Set the selected value
        const targetRadio = form.querySelector(`input[name="sort_by"][value="${value}"]`);
        if (targetRadio) {
          targetRadio.checked = true;
          this.activeSort = value;
          
          // Update URL parameters
          this.updateURLParams({ sort_by: value });
          
          // form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    },

    async updateProductCount() {
      this.loading = true;
      console.log('Updating product count...');

      try {
        const form = document.querySelector('.c-filter-form');
        if (!form) {
          console.error('Filter form not found');
          this.loading = false;
          return;
        }

        // Create FormData from the current form state
        const formData = new FormData(form);
        
        // Build URL with form action and parameters
        const actionUrl = form.action || window.location.pathname;
        const url = new URL(actionUrl, window.location.origin);
        
        // Add all form data as URL parameters
        for (let [key, value] of formData.entries()) {
          if (value && value !== '') {
            url.searchParams.append(key, value);
          }
        }

        console.log('Fetching filtered collection page:', url.toString());
        
        const response = await fetch(url.toString());
        if (response.ok) {
          const html = await response.text();
          console.log('Form submission response received');
          
          // Parse the HTML response to extract product count
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Look for the collection count in the data attribute
          const collectionData = doc.querySelector('[data-collection-count]');
          if (collectionData) {
            const productCount = parseInt(collectionData.dataset.collectionCount) || 0;
            console.log('Product count found in response:', productCount);
            this.productCount = productCount;
          } else {
            console.warn('Could not find collection count in response');
            // Fallback: count product cards in the response
            const productCards = doc.querySelectorAll('[data-product-id], .c-product-card, .product-card');
            const fallbackCount = productCards.length;
            console.log('Fallback product count from product cards:', fallbackCount);
            this.productCount = fallbackCount;
          }
        } else {
          console.error('Failed to fetch filtered collection:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error updating product count:', error);
      }

      this.loading = false;
    },

    getProductCountText() {
      if (this.loading) return 'Loading...';
      
      // Check if any filters are active
      const form = document.querySelector('.c-filter-form');
      if (!form) return 'View Products';
      
      const formData = new FormData(form);
      let hasActiveFilters = false;
      
      for (let [key, value] of formData.entries()) {
        // Check for any filter parameters (excluding empty values)
        if (key.startsWith('filter.') && value && value !== '') {
          // Skip product_type filter if it's empty (means "Everything" is selected)
          if (key === 'filter.p.product_type' && value === '') continue;
          hasActiveFilters = true;
          break;
        }
        // Also check for non-default sort_by
        if (key === 'sort_by' && value && value !== 'featured') {
          hasActiveFilters = true;
          break;
        }
      }
      
      if (!hasActiveFilters) {
        return 'View Products';
      }
      
      return `View ${this.productCount} Product${this.productCount !== 1 ? 's' : ''}`;
    },

    async reset() {
      // Clear all form inputs and submit
      const form = document.querySelector('.c-filter-form');
      if (form) {
        // Reset all form inputs
        const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"]');
        inputs.forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          } else if (input.type === 'number') {
            input.value = '';
          }
        });
        
        // Check the default "everything" radio for product type
        const everythingRadio = form.querySelector('input[name="filter.p.product_type"][value=""]');
        if (everythingRadio) {
          everythingRadio.checked = true;
        }
        
        // Check the default "featured" radio for sort
        const featuredRadio = form.querySelector('input[name="sort_by"][value="featured"]');
        if (featuredRadio) {
          featuredRadio.checked = true;
        }
        
        this.activeProductType = '';
        this.activeSort = 'featured';
        
        // Clear URL parameters
        this.clearURLParams();
        
        // Update filter counts for all accordions after reset
        const accordionElements = form.querySelectorAll('[x-data="filterAccordion"]');
        accordionElements.forEach(element => {
          const accordionData = Alpine.$data(element);
          if (accordionData && accordionData.getFilterCount) {
            accordionData.getFilterCount(element);
          }
        });
        
        // Update preview count briefly before submitting
        await this.updateProductCount();
        
        // Announce reset to screen readers
        const gridStatus = document.getElementById('product-grid-status');
        if (gridStatus) {
          gridStatus.textContent = 'Resetting filters...';
        }
        
        // Then submit form which will close drawer automatically
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        // Close drawer
        this.isOpen = false;
      }
    },

    updateURLParams(params) {
      const url = new URL(window.location);
      
      // Update or remove parameters
      Object.entries(params).forEach(([key, value]) => {
        if (value === '' || value === null || value === undefined) {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, value);
        }
      });
      
      // Update browser history without triggering page reload
      window.history.replaceState({}, '', url);
    },

    clearURLParams() {
      const url = new URL(window.location);
      
      // Remove all filter and sort parameters
      url.searchParams.delete('filter.p.product_type');
      url.searchParams.delete('sort_by');
      
      // Remove any other filter parameters that might exist
      const keysToRemove = [];
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => url.searchParams.delete(key));
      
      // Update browser history without triggering page reload
      window.history.replaceState({}, '', url);
    },

    // Method to update URL params from current form state (called by Alpine @change events)
    updateAllFilterParams() {
      const form = document.querySelector('.c-filter-form');
      if (!form) return;

      const formData = new FormData(form);
      const params = {};

      // Collect all form data
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('filter.') || key === 'sort_by') {
          // For checkboxes, we need to handle multiple values
          if (params[key]) {
            // Convert to array if multiple values exist
            if (Array.isArray(params[key])) {
              params[key].push(value);
            } else {
              params[key] = [params[key], value];
            }
          } else {
            params[key] = value;
          }
        }
      }

      // Handle unchecked checkboxes (they won't appear in FormData)
      const allFilterInputs = form.querySelectorAll('input[name^="filter."], input[name="sort_by"]');
      allFilterInputs.forEach(input => {
        if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) {
          // For unchecked inputs, check if any checkbox with this name is checked
          if (input.name !== 'filter.p.product_type' && input.name !== 'sort_by') {
            const anyChecked = form.querySelector(`input[name="${input.name}"]:checked`);
            if (!anyChecked) {
              params[input.name] = null; // Will be removed from URL
            }
          }
        }
      });

      this.updateURLParams(params);
    }
  });

  Alpine.data('filterAccordion', () => ({
    isOpen: false,
    filterCount: 0,

    toggle() {
      this.isOpen = !this.isOpen;
    },

    getFilterCount(element) {
      this.filterCount = element.closest('.c-accordion').querySelectorAll('.c-accordion__content input[type=\"checkbox\"]:checked').length;
    },
  }));

  Alpine.data('filterCount', () => ({
    filterCount: 0,
    init() {
      this.$watch('$store.filterDrawer.isOpen', () => {
        this.getFilterCount();
      })
    },
    getFilterCount() {
      this.filterCount = document.querySelectorAll('.c-filter-form .c-accordion input[type=\"checkbox\"]:checked').length;
    }
  }));
});
